/* eslint-disable @typescript-eslint/naming-convention */
import { motion } from 'framer-motion';
import { FC } from 'react';

import Button from '../Button';
import ButtonArrow from '../ButtonArrow';
import Heading from '../Heading';
import PreHeading from '../PreHeading';
import Prose from '../Prose';

export interface StandardTextProps {
  blok: any;
}

const TwoColumnStandard: FC<StandardTextProps> = ({ blok }) => {
  const { pre_headline, headline, content, actions, pre_heading, heading } =
    blok;

  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.35,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 75,
        mass: 0.75,
        duration: 0.35,
      },
    },
  };

  return (
    <>
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
        className="grid gap-12 align-bottom md:grid-cols-2"
      >
        <div>
          <motion.div variants={item} className="space-y-8">
            <div className="space-y-2">
              {(pre_headline || pre_heading) && (
                <PreHeading
                  dot={true}
                  size="md"
                  element="h2"
                  color="primary"
                  className="font-normal"
                >
                  {pre_headline || pre_heading}
                </PreHeading>
              )}
              {(headline || heading) && (
                <Heading
                  size="md"
                  weight="semi"
                  element={pre_headline ? 'p' : 'h2'}
                >
                  {headline || heading}
                </Heading>
              )}
            </div>
          </motion.div>
          {actions?.length ? (
            <motion.div variants={item} className="mt-8 flex gap-x-3">
              {actions.map((action) => (
                <Button
                  key={action._uid}
                  link={action.link}
                  style={action.style}
                >
                  <ButtonArrow
                    className={`${action.style} mr-1 -ml-1 h-5 w-6`}
                  />
                  <span className="-mb-0.5">{action.label}</span>
                </Button>
              ))}
            </motion.div>
          ) : null}
        </div>
        {content && (
          <motion.div variants={item} className="self-end">
            <Prose size={'lg'} content={content}></Prose>
          </motion.div>
        )}
      </motion.div>
    </>
  );
};

export default TwoColumnStandard;
